import { render, staticRenderFns } from "./TemplatePurchase.vue?vue&type=template&id=b1678d8c"
import script from "./TemplatePurchase.vue?vue&type=script&lang=js"
export * from "./TemplatePurchase.vue?vue&type=script&lang=js"
import style0 from "./TemplatePurchase.vue?vue&type=style&index=0&id=b1678d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports